import { useState } from 'react'
import './Header.css'

function Header({ 
  title, 
  showBack = false, 
  showSettings = false, 
  showHome = false,
  onBack,
  onSettings,
  onHome,
  rightContent,
  compact = false
}) {
  return (
    <header className={`app-header ${compact ? 'compact' : ''}`}>
      <div className="header-left">
        {showBack && onBack && (
          <button className="header-btn" onClick={onBack} aria-label="Go back">
            <span className="header-icon">←</span>
          </button>
        )}
        {showHome && onHome && (
          <button className="header-btn" onClick={onHome} aria-label="Go home">
            <span className="header-icon">🏠</span>
          </button>
        )}
      </div>

      <div className="header-center">
        {title && <h1 className="header-title">{title}</h1>}
      </div>

      <div className="header-right">
        {rightContent}
        {showSettings && onSettings && (
          <button className="header-btn" onClick={onSettings} aria-label="Settings">
            <span className="header-icon">⚙️</span>
          </button>
        )}
      </div>
    </header>
  )
}

// Settings Modal Component
export function SettingsModal({ isOpen, onClose, userSettings, onResetOnboarding }) {
  if (!isOpen) return null

  const ageLabels = {
    little: 'Ages 4-6',
    middle: 'Ages 7-9', 
    bigger: 'Ages 10-12'
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>⚙️ Settings</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        
        <div className="modal-body">
          <div className="setting-row">
            <span className="setting-label">Age Group</span>
            <span className="setting-value">{ageLabels[userSettings?.ageGroup] || 'Not set'}</span>
          </div>
          
          <div className="setting-row">
            <span className="setting-label">Language Mode</span>
            <span className="setting-value">
              {userSettings?.learnerMode ? '📖 Learning' : '🏠 Native'}
            </span>
          </div>

          <div className="settings-divider" />

          <button className="settings-action" onClick={onResetOnboarding}>
            <span>🔄 Change Age Group</span>
            <span className="action-hint">Restart setup</span>
          </button>

          <button className="settings-action danger" onClick={() => {
            localStorage.clear()
            window.location.reload()
          }}>
            <span>🗑️ Reset Everything</span>
            <span className="action-hint">Clear all data</span>
          </button>
        </div>

        <div className="modal-footer">
          <p className="about-text">
            📚 StoryPath • A Free Friday Project
          </p>
        </div>
      </div>
    </div>
  )
}

export default Header
